export default "__VITE_ASSET__ELmmZ9W8__"